module.exports = __webpack_public_path__ + "img/pro_one_2.039ead7e.jpg";